   $(document).ready(function(){
  //  $("body.template--product .product-type-banner--root").sticky({topSpacing:113});

  }); 